export default __webpack_public_path__ + "static/media/bars.8501870d.svg";